import {NgModule}                        from '@angular/core';
import {CommonModule}                    from '@angular/common';
import {ApDynComponentModule}            from '../ap-dyncomponent/ap-dyncomponent.module';
import {TaskManagementRoutes}            from './task-management.routes';
import {ApCoreModule}                    from '../ap-core/ap-core.module';
import {ApResponsiveTextModule}          from '../ap-responsive-text/ap-responsive-text.module';
import {ButtonModule}                    from '@progress/kendo-angular-buttons';
import {TaskManagementOverviewComponent} from './components/task-management-overview.component';
import {TaskManagementWizardComponent}   from './components/wizard/task-management-wizard.component';
import {ApReportsModule}                 from '../ap-reports/ap-reports.module';
import {ApMapModule}                 from '../map/ap-map.module';
import {TaskManagementEditComponent} from './components/editing/task-management-edit.component';

@NgModule({
  declarations: [
    TaskManagementOverviewComponent,
    TaskManagementWizardComponent,
    TaskManagementEditComponent
  ],
  exports: [
    TaskManagementOverviewComponent,
    TaskManagementWizardComponent
  ],
  imports: [
    CommonModule,
    ApDynComponentModule,
    TaskManagementRoutes,
    ApCoreModule,
    ApResponsiveTextModule,
    ButtonModule,
    ApReportsModule,
    ApMapModule
  ],
  providers: []
})
export class TaskManagementModule {
}
